import React from 'react'

// Importing SVG icons
// You may need to import the actual SVG files or their corresponding components here
import { ReactComponent as IconArrowRight } from '../assets/svgs/icons/IconArrowRight.svg'
import { ReactComponent as IconMessageAlertSquare } from '../assets/svgs/icons/IconMessageAlertSquare.svg'
import { ReactComponent as IconUserCircle } from '../assets/svgs/icons/IconUserCircle.svg'
import { ReactComponent as IconLock } from '../assets/svgs/icons/IconLock.svg'
import { ReactComponent as IconEye } from '../assets/svgs/icons/IconEye.svg'
import { ReactComponent as IconEyeOff } from '../assets/svgs/icons/IconEyeOff.svg'
import { ReactComponent as IconAlertTriangle } from '../assets/svgs/icons/IconAlertTriangle.svg'
import { ReactComponent as IconFillCheckbox } from '../assets/svgs/icons/IconFillCheckbox.svg'
import { ReactComponent as IconCheckMonogram } from '../assets/svgs/icons/IconCheckMonogram.svg'
import { ReactComponent as Profile } from '../assets/svgs/icons/profile.svg'
import { ReactComponent as IconArrowLeft } from '../assets/svgs/icons/IconArrowLeft.svg'
import { ReactComponent as IconHomeInActive } from '../assets/svgs/icons/IconHomeLine.svg'
import { ReactComponent as IconFolderInActive } from '../assets/svgs/icons/IconFolderCheck.svg'
import { ReactComponent as IconFileCheckInActive } from '../assets/svgs/icons/IconFileCheck.svg'
import { ReactComponent as IconGraduationHatInActive } from '../assets/svgs/icons/IconGraduationHat.svg'
import { ReactComponent as IconMessageChatSquareInActive } from '../assets/svgs/icons/IconMessageChatSquare.svg'
import { ReactComponent as IconAlertTriangleInActive } from '../assets/svgs/icons/IconAlertTriangleInactive.svg'
import { ReactComponent as IconAnnotationAlertInActive } from '../assets/svgs/icons/IconAnnotationAlert.svg'
import { ReactComponent as IconToolInActive } from '../assets/svgs/icons/IconTool.svg'
import { ReactComponent as IconMail } from '../assets/svgs/icons/IconMail.svg'
import { ReactComponent as IconArrowNarrowLeft } from '../assets/svgs/icons/IconArrowNarrowLeft.svg'
import { ReactComponent as IconPasscodeLock } from '../assets/svgs/icons/IconPasscodeLock.svg'
import { ReactComponent as IconCheckVerified } from '../assets/svgs/icons/IconCheckVerified.svg'
import { ReactComponent as IconEdit } from '../assets/svgs/icons/IconEdit.svg'
import { ReactComponent as IconBellAlert } from '../assets/svgs/icons/IconBellAlert.svg'
import { ReactComponent as IconSetting } from '../assets/svgs/icons/IconSettings.svg'
import { ReactComponent as IconSearchSm } from '../assets/svgs/icons/IconSearchSm.svg'
import { ReactComponent as Monogram } from '../assets/svgs/icons/Monogram.svg'
import { ReactComponent as IconCheckCircle } from '../assets/svgs/icons/IconCheckCircle.svg'
import { ReactComponent as IconXClose } from '../assets/svgs/icons/IconXClose.svg'
import { ReactComponent as IconGlobe } from '../assets/svgs/icons/IconGlobe.svg'
import { ReactComponent as IconCopy } from '../assets/svgs/icons/IconCopy.svg'
import { ReactComponent as IconFilePlus } from '../assets/svgs/icons/IconFilePlus.svg'
import { ReactComponent as IconCross } from '../assets/svgs/icons/IconCross.svg'
import { ReactComponent as IconArrowDown } from '../assets/svgs/icons/IconArrowDown.svg'
import { ReactComponent as IconCalander } from '../assets/svgs/icons/IconCalendar.svg'
import { ReactComponent as IconChevronDown } from '../assets/svgs/icons/IconChevronDown.svg'
import { ReactComponent as IconDotsVertical } from '../assets/svgs/icons/IconDotsVertical.svg'
import { ReactComponent as IconChevronRight } from '../assets/svgs/icons/IconChevronRight.svg'
import { ReactComponent as IconTrash } from '../assets/svgs/icons/IconTrash.svg'
import { ReactComponent as IconFileMinus } from '../assets/svgs/icons/IconFileMinus.svg'
import { ReactComponent as IconExportData } from '../assets/svgs/icons/IconExportData.svg'
import { ReactComponent as IconChevronUp } from '../assets/svgs/icons/IconChevronUp.svg'
import { ReactComponent as IconPlus } from '../assets/svgs/icons/IconPlus.svg'
import { ReactComponent as IconBarChartSquare } from '../assets/svgs/icons/IconBarChartSquare.svg'
import { ReactComponent as IconAttachment } from '../assets/svgs/icons/IconAttachment.svg'
import { ReactComponent as IconCalanderPlus } from '../assets/svgs/icons/IconCalendarPlus.svg'
import { ReactComponent as IconFile } from '../assets/svgs/icons/IconFile.svg'
import { ReactComponent as exportIcon } from '../assets/svgs/icons/exportIcon.svg'
import { ReactComponent as copyIcon } from '../assets/svgs/icons/copyIcon.svg'
import { ReactComponent as IconDownloadCloud } from '../assets/svgs/icons/IconDownloadCloud.svg'
import { ReactComponent as IconRefresh } from '../assets/svgs/icons/IconRefresh.svg'
import { ReactComponent as IconBuilding } from '../assets/svgs/icons/IconBuilding.svg'
import { ReactComponent as IconMarkerPin } from '../assets/svgs/icons/IconMarkerPin.svg'
import { ReactComponent as IconTool } from '../assets/svgs/icons/IconTool.svg'
import { ReactComponent as IconUploadCloud } from '../assets/svgs/icons/IconUploadCloud.svg'
import { ReactComponent as IconCheck } from '../assets/svgs/icons/IconCheck.svg'
import { ReactComponent as IconAlertCircle } from '../assets/svgs/icons/IconAlertCircle.svg'
import { ReactComponent as IconCircle } from '../assets/svgs/icons/IconCircle.svg'
import { ReactComponent as IconRadio } from '../assets/svgs/icons/IconRadio.svg'
import { ReactComponent as IconShare } from '../assets/svgs/icons/IconShare.svg'
import { ReactComponent as IconCodeSquare } from '../assets/svgs/icons/IconCodeSquare.svg'
import { ReactComponent as IconBarChartCircle } from '../assets/svgs/icons/IconBarChartCircle.svg'
import { ReactComponent as IconList } from '../assets/svgs/icons/IconList.svg'
import { ReactComponent as IconFolder } from '../assets/svgs/icons/IconFolder.svg'
import { ReactComponent as IconStickerSquare } from '../assets/svgs/icons/IconStickerSquare.svg'
import { ReactComponent as IconUserPlus } from '../assets/svgs/icons/IconUserPlus.svg'
import { ReactComponent as IconFolderPlus } from '../assets/svgs/icons/IconFolderPlus.svg'
import { ReactComponent as IconPauseCircle } from '../assets/svgs/icons/IconPauseCircle.svg'
import { ReactComponent as IconInfoCircle } from '../assets/svgs/icons/IconInfoCircle.svg'
import { ReactComponent as IconDownload } from '../assets/svgs/icons/IconDownload.svg'
import { ReactComponent as IconUsersCheck } from '../assets/svgs/icons/IconUsersCheck.svg'
import { ReactComponent as IconPDFRed } from '../assets/svgs/icons/IconPDFRed.svg'
import { ReactComponent as IconPDFGreen } from '../assets/svgs/icons/IconPDFGreen.svg'
import { ReactComponent as IconPDFYellow } from '../assets/svgs/icons/IconPDFYellow.svg'
import { ReactComponent as IconPDFBule } from '../assets/svgs/icons/IconPDFBule.svg'
import { ReactComponent as IconLogout } from '../assets/svgs/icons/IconLogOut.svg'
import { ReactComponent as IconArchive } from '../assets/svgs/icons/IconArchive.svg'

// Define the props interface for the Icon component
interface IconProps {
  name: keyof typeof icons // The name of the icon, which corresponds to the key in the `icons` object
  strokeWidth?: number // Optional prop for the stroke width of the icon
  stroke?: string // Optional prop for the stroke color of the icon
  strokeLinecap?: 'butt' | 'round' | 'square' | 'inherit' // Optional prop for the stroke linecap of the icon
  width?: number // Optional prop for the width of the icon
  height?: number // Optional prop for the height of the icon
}

// Define the icons using React component imports
const icons: { [key: string]: React.FC<React.SVGProps<SVGSVGElement>> } = {
  // List of imported icons
  IconArrowRight,
  IconMessageAlertSquare,
  IconUserCircle,
  IconLock,
  IconEye,
  IconEyeOff,
  IconAlertTriangle,
  IconFillCheckbox,
  IconCheckMonogram,
  Profile,
  IconArrowLeft,
  IconHomeInActive,
  IconFolderInActive,
  IconFileCheckInActive,
  IconGraduationHatInActive,
  IconMessageChatSquareInActive,
  IconAlertTriangleInActive,
  IconAnnotationAlertInActive,
  IconToolInActive,
  IconMail,
  IconArrowNarrowLeft,
  IconPasscodeLock,
  IconCheckVerified,
  IconEdit,
  IconBellAlert,
  IconSetting,
  IconSearchSm,
  Monogram,
  IconCheckCircle,
  IconXClose,
  IconGlobe,
  IconCopy,
  IconFilePlus,
  IconCross,
  IconArrowDown,
  IconCalander,
  IconChevronDown,
  IconDotsVertical,
  IconChevronRight,
  IconTrash,
  IconFileMinus,
  IconExportData,
  IconAttachment,
  IconChevronUp,
  IconPlus,
  IconBarChartSquare,
  IconCalanderPlus,
  IconFile,
  exportIcon,
  copyIcon,
  IconDownloadCloud,
  IconRefresh,
  IconBuilding,
  IconMarkerPin,
  IconTool,
  IconUploadCloud,
  IconCheck,
  IconAlertCircle,
  IconCircle,
  IconRadio,
  IconShare,
  IconCodeSquare,
  IconBarChartCircle,
  IconList,
  IconFolder,
  IconStickerSquare,
  IconUserPlus,
  IconFolderPlus,
  IconPauseCircle,
  IconInfoCircle,
  IconDownload,
  IconUsersCheck,
  IconPDFRed,
  IconPDFGreen,
  IconPDFYellow,
  IconPDFBule,
  IconLogout,
  IconArchive 
}

// Icon component that takes the icon name and other optional props
export const Icon: React.FC<IconProps> = ({
  name,
  strokeWidth = 1.5,
  stroke = '',
  strokeLinecap = 'round',
  width = 24,
  height = 24,
}) => {
  // Check if the provided icon name exists in the `icons` object
  if (!(name in icons)) {
    return null
  }

  // Get the appropriate React component for the given icon name
  const IconComponent = icons[name]

  // Render the icon component with the provided props
  return (
    <IconComponent
      strokeWidth={strokeWidth}
      stroke={stroke}
      width={width}
      height={height}
      strokeLinecap={strokeLinecap}
      name={''}
    />
  )
}
